module.exports = __webpack_public_path__ + "static/media/woollen-coat1024.77121ca5.jpg";